module.exports = __webpack_public_path__ + "assets/img/Guide04.84d21b68.png";